import React from "react";
import PropTypes from "prop-types";
import { Button, Card, CardContent, IconButton, Stack, TextField, Typography } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";

import { contentEditorCardSx, contentCardContentSx, contentFieldSx, contentSectionTitleSx } from "../contentEditorStyles";

const SuggestedProductsEditor = ({ products, onChange }) => {
  const updateProduct = (index, value) => {
    onChange(products.map((product, currentIndex) => (currentIndex === index ? value : product)));
  };

  return (
    <Card sx={contentEditorCardSx}>
      <CardContent sx={contentCardContentSx}>
        <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 1 }}>
          <Typography sx={contentSectionTitleSx}>Prodotti suggeriti</Typography>
          <Button size="small" startIcon={<AddIcon />} onClick={() => onChange([...products, ""])}>
            Aggiungi
          </Button>
        </Stack>
        <Stack spacing={1}>
          {products.length === 0 ? (
            <Typography variant="body2" color="text.secondary">Nessun prodotto suggerito configurato.</Typography>
          ) : (
            products.map((product, index) => (
              <Stack key={`product-${index}`} direction="row" spacing={1}>
                <TextField
                  fullWidth
                  size="small"
                  label={`Etichetta ricerca ${index + 1}`}
                  value={product}
                  onChange={(event) => updateProduct(index, event.target.value)}
                  sx={contentFieldSx}
                />
                <IconButton color="error" onClick={() => onChange(products.filter((_, currentIndex) => currentIndex !== index))}>
                  <DeleteIcon />
                </IconButton>
              </Stack>
            ))
          )}
        </Stack>
      </CardContent>
    </Card>
  );
};

SuggestedProductsEditor.propTypes = {
  products: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default SuggestedProductsEditor;
